import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AccountUpgradePopupComponent } from 'app/account-upgrade/account-upgrade-popup/account-upgrade-popup.component';

@Injectable({ providedIn: 'root' })
export class AccountUpgradePopupService {
  private dialogRef: any;
  constructor(private dialog: MatDialog) {}

  public openPopup(access: string) {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
    this.dialogRef = this.dialog.open(AccountUpgradePopupComponent, {
      maxWidth: 800,
      hasBackdrop: false,
      data: { triedToAccess: access },
    });
  }
}
